module.exports = __webpack_public_path__ + "img/cert_03.3ca516a3.jpg";